import { createSlice } from '@reduxjs/toolkit'
import { fetchAllSessions } from '../actions/sessionActions.js'

const initialState = {
  sessions: {
    users: 0,
    sessions: 0,
    sessionDuration: 0,
    pageViews: 0,
    uniqueVisitors: 0,
    usersGrowth: 0,
    sessionsGrowth: 0,
    sessionDurationGrowth: 0,
    pageViewsGrowth: 0,
    uniqueVisitorsGrowth: 0
  },
  loading: false,
  error: null
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAllSessions.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAllSessions.fulfilled, (state, action) => {
        const payload = action.payload
        const analytics = payload.analytics || {}
        
        // Transform the analytics data to match our state structure
        const transformedData = {
          users: analytics.uniqueVisitors || 0,
          sessions: analytics.activeSessions + analytics.inactiveSessions || analytics.totalSessionsInPage || 0,
          sessionDuration: analytics.avgSessionDurationMinutes || 0,
          pageViews: analytics.pageViews || 0,
          uniqueVisitors: analytics.uniqueVisitors || 0,
          usersGrowth: 0, // Growth data not provided in current API response
          sessionsGrowth: 0,
          sessionDurationGrowth: 0,
          pageViewsGrowth: 0,
          uniqueVisitorsGrowth: 0
        }
        
        state.sessions = transformedData
        state.loading = false
      })
      .addCase(fetchAllSessions.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false
      })
  }
})

export const { clearError } = sessionSlice.actions
export default sessionSlice.reducer